export default "__VITE_ASSET__By8Ts2gN__"